<template>
  <div class="home-landing">
    <home-header
      :translate-menu="translateMenu" :tool-menu="toolMenu" :user-info="userInfo"
      :group-user-info="groupUserInfo" :group-user-infos="groupUserInfos"
      :showlogin-out="showloginOut" :is-show-in-roaming="isShowInRoaming"
      :show-roaming="showRoaming" :qrcode-url="qrcodeUrl"
      @navigate="toPath" @translate="runTranslate" @tool="runTool"
      @services="openProductAdvantages" @partners="openPartners" @command="logOut"
      @institution-login="openLogin" @login="openLogin"
      @register="showIframe('/register')" @qrcode-show="getQrcode" @qrcode-hide="removeQrcode"
      @banner-close="bannerClosed = true"
    />

    <main>
      <section class="home-banner" aria-label="首页横幅">
        <div :class="['banner-spacer', { 'banner-spacer--collapsed': bannerClosed }]"></div>
        <div class="banner-inner">
          <div class="banner-content">
            <h2 class="banner-title">微思学术<span class="banner-highlight">无所不至</span></h2>
            <p class="banner-subtitle">微思翻译无不可译</p>
            <p class="banner-desc">打造专业、高效、便捷的翻译管理平台，协助用户快速完成文档翻译，为用户提供一站式翻译解决方案</p>
          </div>
        </div>
      </section>

      <section class="promise-band">
        <div class="promise-inner">
          <p>汇集全球海量人才资源，打造权威翻译团队</p>
          <ul>
            <li>致力于提供精准高效的翻译服务</li>
            <li>支持20多种语言翻译，多种文档格式</li>
            <li>保留原文格式，提供多种类型服务</li>
            <li>多年翻译经验，严格把控翻译质量</li>
            <li>全天候的专家小组确保售后无忧</li>
          </ul>
        </div>
      </section>

      <section id="services" ref="services" class="services">
        <div class="service-grid">
          <button
            v-for="(item, index) in services"
            :key="item.title"
            :class="['service-card', 'service-' + (index + 1)]"
            type="button"
            :data-track-id="'home.services.' + item.type"
            :data-track-text="item.title"
            data-track-component="HomeLandingServices"
            :data-track-business-id="item.type"
            @click="gotoPage(item.type)"
          >
            <h3>{{ item.title }}</h3>
            <p>{{ item.desc }}</p>
          </button>
        </div>
      </section>

    </main>

    <home-footer @license="toPath('/license')" />

    <home-activity-notice
      v-if="payCenterDialogVisible2 && activityNotice"
      :notice="activityNotice"
      @close="payCenterDialogVisible2Close"
    />
    <floating-contact-tools />
  </div>
</template>

<script>
import NewIndex from './NewIndex.vue'
import HomeHeader from '@/components/home/HomeHeader.vue'
import HomeFooter from '@/components/home/HomeFooter.vue'
import FloatingContactTools from '@/components/home/FloatingContactTools.vue'
import HomeActivityNotice from '@/components/home/HomeActivityNotice.vue'

export default {
  name: 'HomeLanding',
  extends: NewIndex,
  components: {
    HomeHeader,
    HomeFooter,
    FloatingContactTools,
    HomeActivityNotice
  },
  data () {
    return {
      bannerClosed: false,
      translateMenu: [
        { label: '文本翻译', desc: '支持304种语言、近4万个翻译方向', type: 'text', icon: 'el-icon-document' },
        { label: '文档翻译', desc: '一键上传，高度保留原文样式排版', type: 'doc', icon: 'el-icon-folder' },
        { label: 'AI翻译', desc: 'AI驱动，精准流畅的多语言转换', type: 'ai', icon: 'el-icon-cpu' },
        { label: '多语种翻译', desc: '保留原文译文对应关系', type: 'lange', icon: 'el-icon-connection' },
        { label: '图片翻译', desc: '粘贴图片即可识别文本快速翻译', type: 'img', icon: 'el-icon-picture-outline' },
        { label: '网页翻译', desc: '快速翻译任意网页内容', type: 'webTranslate', icon: 'el-icon-monitor' }
      ],
      toolMenu: [
        { label: '润色改写', desc: '智能润色，提升文章表达质量', action: 'polish', icon: 'el-icon-magic-stick' },
        { label: 'AI PPT', desc: 'AI一键生成专业演示文稿', action: 'aiPPT', icon: 'el-icon-data-board' },
        { label: 'RAG知识库', desc: '构建专属知识库，精准检索', action: 'rag', icon: 'el-icon-collection' },
        { label: '人工翻译', desc: '汇集全球海量人才，权威翻译团队', action: 'toTransPro', icon: 'el-icon-service' },
        { label: '术语词库', desc: '设定规则，提高译文一致性', action: 'standLangSet', icon: 'el-icon-notebook-2' },
        { label: '文档转换', desc: '多格式文档互转，高保真输出', action: 'convertDoc', icon: 'el-icon-document-copy' },
        { label: '数据分析', desc: 'AI智能抓取分析，生成RAG报告', action: 'smartClassify', icon: 'el-icon-data-analysis' },
        { label: '我的文档', desc: '翻译记录管理，便捷查找历史', action: 'mySelfDoc', icon: 'el-icon-folder-opened' },
        { label: '聚合数据库检索', desc: '聚合开放获取文献，快速检索DOI、引用和PDF', action: 'scholar', icon: 'el-icon-search' },
        { label: '分类预测', desc: '上传Excel批量预测内容分类', action: 'categoryTool', icon: 'el-icon-s-grid' },
        { label: '素材提取', desc: '从 Word / PDF 提取目录、表格、图片等素材', action: 'materialExtract', icon: 'el-icon-files' }
      ],
      services: [
        { title: '文本翻译', desc: '支持全球304种语言、近4万个翻译方向，满足跨语言交流的需求。', type: 'text' },
        { title: '文档翻译', desc: '支持多种格式文档，一键上传全篇翻译，高度保留样式和排版，双语对照查看。', type: 'doc' },
        { title: 'AI翻译', desc: '通过人工智能技术，实现多语言之间的高效转换，提供更精准且流畅的翻译结果。', type: 'ai' },
        { title: '多语种翻译', desc: '提供多语种翻译，轻松转化为目标语言，同时保留原文和译文的对应关系。', type: 'lange' },
        { title: '图片翻译', desc: '粘贴图片到输入框，快速识别图片中的文本内容并翻译。', type: 'img' },
        { title: '人工翻译', desc: '汇集全球海量人才资源，多年翻译经验，严格把控翻译质量，打造权威翻译团队。', type: 'pro' }
      ]
    }
  },
  mounted () {
    if (this.$route.hash === '#services') {
      this.$nextTick(() => window.setTimeout(this.scrollToServices, 0))
    }
  },
  methods: {
    openProductAdvantages () {
      this.$router.push('/about')
    },
    openPartners () {
      this.$router.push('/partners')
    },
    openLogin () {
      if (this.hasH5 || window.matchMedia('(max-width: 768px)').matches) {
        if (this.$layer && this.$layer.closeAll) this.$layer.closeAll()
        if (this.$route.path !== '/h5/login') this.$router.push('/h5/login')
        return
      }
      this.showIframe(process.env.VUE_APP_WEB_LOGIN_URL)
    },
    runTranslate (type) {
      if (type === 'webTranslate') {
        this.logOut(type)
        return
      }
      this.gotoPage(type)
    },
    runTool (action) {
      if (action === 'materialExtract') {
        this.toPath('/extract')
        return
      }
      if (['polish', 'aiPPT', 'rag', 'scholar', 'categoryTool'].includes(action)) {
        this.gotoPage(action)
        return
      }
      this.logOut(action)
    },
    scrollToServices () {
      this.$refs.services.scrollIntoView({ behavior: 'smooth' })
    }
  }
}
</script>

<style scoped>
.home-landing { min-height: 100vh; display: flex; flex-direction: column; color: #1a1a2e; background: #f5f8fa; font-family: "Noto Sans SC", "Microsoft YaHei", sans-serif; }
main { flex: 1; display: flex; flex-direction: column; }
button { font: inherit; }
.home-nav { position: fixed; z-index: 50; top: 0; right: 0; left: 0; background: rgba(255,255,255,.96); box-shadow: 0 2px 20px rgba(62,109,119,.08); }
.nav-inner { width: calc(100% - 48px); max-width: 1216px; height: 64px; margin: 0 auto; display: flex; align-items: center; justify-content: space-between; }
.brand, .desktop-nav > button, .nav-group > button, .nav-actions button { border: 0; background: transparent; color: #333; cursor: pointer; }
.brand { display: flex; align-items: center; gap: 8px; padding: 0; font-size: 16px; font-weight: 700; }
.brand img { width: 32px; height: 32px; object-fit: cover; }
.desktop-nav { display: flex; align-items: center; justify-content: center; gap: 6px; margin-left: 150px; }
.desktop-nav > button, .nav-group > button { padding: 9px 16px; font-size: 14px; font-weight: 500; }
.nav-group { position: relative; }
.nav-group:hover .mega-menu, .nav-group:focus-within .mega-menu { opacity: 1; visibility: visible; transform: translateY(0); }
.mega-menu { position: absolute; top: 44px; left: 0; width: 640px; padding: 18px; display: grid; grid-template-columns: repeat(2, 1fr); gap: 8px; border: 1px solid #e3eceb; border-radius: 16px; background: #fff; box-shadow: 0 8px 40px rgba(62,109,119,.12); opacity: 0; visibility: hidden; transform: translateY(-8px); transition: .18s ease; }
.tools-menu { left: -150px; }
.menu-title { grid-column: 1 / -1; margin: 0 0 5px; padding: 0 4px 12px; color: #6b7280; font-size: 13px; font-weight: 600; border-bottom: 1px solid #e3eceb; }
.mega-menu button { display: flex; flex-direction: column; gap: 4px; padding: 9px 10px; text-align: left; border: 0; border-radius: 9px; color: #1a1a2e; background: #fff; cursor: pointer; }
.mega-menu button:hover { background: #f0f6ff; }
.mega-menu strong { font-size: 13px; }.mega-menu em { color: var(--primary); font-size: 9px; font-style: normal; }.mega-menu span { color: #7b858d; font-size: 11px; }
.nav-actions { display: flex; align-items: center; gap: 3px; white-space: nowrap; }.nav-actions button { padding: 8px 10px; font-size: 14px; }.nav-actions .register { margin-left: 4px; padding: 8px 17px; color: #fff; font-weight: 600; border-radius: 9px; background: var(--primary); box-shadow: 0 5px 14px var(--primary-alpha-22); }.identity-dropdown { display: inline-flex; align-items: center; }.identity-button { max-width: 190px; display: inline-flex; align-items: center; gap: 5px; }.identity-button span { overflow: hidden; text-overflow: ellipsis; }.identity-button .el-icon-office-building { color: var(--foreground-secondary); }.roaming-button { color: var(--primary) !important; }.dropdown-action { margin-left: 12px; color: #909399; }
.home-banner{width:100%;background:var(--primary-light);box-sizing:border-box}.banner-spacer{height:144px}.banner-spacer--collapsed{height:64px}.banner-inner{padding-left:40px;padding-right:40px;padding-top:60px;padding-bottom:60px;box-sizing:border-box;min-height:280px}.banner-content{display:flex;flex-direction:column;gap:10px}.banner-title{margin:0;font-size:42px;font-weight:800;color:#1a1a2e;letter-spacing:3px;line-height:1.3}.banner-highlight{color:#059669}.banner-subtitle{margin:0;font-size:22px;font-weight:600;color:#374151;line-height:1.4}.banner-desc{margin:0;max-width:600px;font-size:15px;color:#6b7280;line-height:1.7}
@media (min-width: 1441px) {
}
.promise-band { height: 88px; color: #fff; background: var(--primary-gradient); }
.promise-inner { width: calc(100% - 80px); height: 100%; margin: 0 auto; display: flex; align-items: center; gap: 55px; }
.promise-inner > p { height: 100%; flex: 0 0 330px; margin: 0; display: flex; align-items: center; font-size: 16px; font-weight: 600; white-space: nowrap; }.promise-inner ul { flex: 1; margin: 0; padding: 0; display: grid; grid-template-columns: repeat(3,auto); gap: 12px 28px; list-style-position: inside; font-size: 14px; font-weight: 400; color: rgba(255,255,255,.92); }
.services { min-height: 327px; flex: 1; box-sizing: border-box; padding: 56px 20px; background: var(--bg-page); }
.service-grid { max-width: 100%; margin: 0 auto; display: grid; grid-template-columns: repeat(4,1fr); gap: 20px; }.service-card { min-height: 106px; min-width: 240px; padding: 20px 24px; text-align: left; color: var(--foreground); border: 0; border-left: 4px solid #60a5fa; border-radius: var(--radius-xl); background: var(--bg-card); cursor: pointer; transition: transform .16s, box-shadow .16s; }.service-card:hover { transform: translateY(-2px); box-shadow: 0 8px 20px rgba(0,0,0,.08); }.service-card h3 { margin: 0 0 6px; font-size: 14px; font-weight: 600; }.service-card p { margin: 0; color: var(--muted-foreground); font-size: 12px; line-height: 1.625; }.service-2 { border-left-color: #818cf8; }.service-3 { border-left-color: #a78bfa; }.service-4 { border-left-color: #22d3ee; }.service-5 { grid-column: span 2; border-left-color: #2dd4bf; }.service-6 { grid-column: span 2; border-left-color: #fb923c; }
footer { height: 64px; color: #a9adbb; background: #19192b; } footer div { max-width: 1216px; height: 100%; margin: 0 auto; padding: 0 24px; display: flex; align-items: center; justify-content: space-between; font-size: 12px; } footer a, footer .footer-link { padding: 0; color: #a9adbb; text-decoration: none; border: 0; background: transparent; cursor: pointer; } footer a:hover, footer .footer-link:hover { color: #fff; text-decoration: underline; } footer span:last-child { display: flex; align-items: center; gap: 20px; }
@media (max-width: 768px) {
  .home-landing { padding-bottom: 58px; box-sizing: border-box; }
  .home-banner .banner-spacer { height: 120px; }
  .home-banner .banner-spacer--collapsed { height: 56px; }
  .banner-inner { padding: 32px 32px 0; }
  .banner-title { font-size: 26px; letter-spacing: 1px; }
  .banner-subtitle { font-size: 16px; }
  .banner-desc { font-size: 13px; }
  .promise-band { height: 88px; }.promise-inner { width: auto; padding: 0 32px; display: flex; }.promise-inner > p { width: 100%; flex: 1; margin: 0; justify-content: center; font-size: 15px; }.promise-inner ul { display: none; }
  .services { padding: 48px 32px; }.service-grid { display: block; }.service-card, .service-5, .service-6 { width: 100%; min-height: 106px; margin-bottom: 21px; padding: 22px 24px; }.service-card:last-child { margin-bottom: 0; }
  footer { height: auto; min-height: 128px; } footer div { padding: 24px 32px; display: block; line-height: 24px; } footer span { display: block; }
}
@media (min-width: 768.01px) and (max-width: 1100px) {
  .home-banner .banner-spacer { height: 192px; }
  .home-banner .banner-spacer--collapsed { height: 64px; }
  .banner-inner { padding: 32px 40px 0; }
  .banner-title { font-size: 32px; }
  .banner-subtitle { font-size: 18px; }
  .banner-desc { max-width: 100%; }
  .promise-band { height: 72px; }.promise-inner { width: auto; padding: 0 32px; }.promise-inner > p { flex: 1; justify-content: center; }.promise-inner ul { display: none; }
  .services { padding: 36px 32px 48px; }.service-grid { grid-template-columns: repeat(2,1fr); gap: 16px; }.service-card, .service-5, .service-6 { grid-column: span 1; min-height: 118px; }
}
</style>
